export var state = {
  inspectType: [{
    label: '全部',
    value: 0
  }, {
    label: '校级检查',
    value: 1
  }, {
    label: '院级检查',
    value: 2
  }, {
    label: '实验室检查',
    value: 3
  }, {
    label: '专家组巡检',
    value: 4
  }],
  taskStatus: [{
    label: '全部',
    value: 0
  }, {
    label: '已发布',
    value: 1
  }, {
    label: '检查中',
    value: 2
  }, {
    label: '整改中',
    value: 3
  }, {
    label: '审批中',
    value: 4
  }, {
    label: '已结束',
    value: 5
  }],
  checkItemStatus: [{
    label: '全部',
    value: 0
  }, {
    label: '待检查',
    value: 1
  }, {
    label: '不通过',
    value: 2
  }, {
    label: '已整改',
    value: 3
  }, {
    label: '整改通过',
    value: 4
  }, {
    label: '通过',
    value: 5
  }],
  roomStatus: [{
    label: '全部',
    value: 0
  }, {
    label: '待检查',
    value: 1
  }, {
    label: '待整改',
    value: 2
  }, {
    label: '待审批',
    value: 3
  }, {
    label: '已通过',
    value: 4
  }]
};
export default {
  namespaced: true,
  state: state
};